module.exports = __webpack_public_path__ + "img/poly-6.44f7cf3f.png";